import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

import globalStyles from './pc-news-card.lightDom.css.lit';
import componentStyles from './pc-news-card.css.lit';

export const newsCardThemes = ['light', 'dark'] as const;
export type NewsCardTheme = (typeof newsCardThemes)[number];

/**
 * Insight News Card component
 * @element pc-news-card
 * @slot - This element has a default slot
 */
@customElement('pc-news-card')
export class PCNewsCard extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  adoptedStylesheets: AdoptedStyleSheets;

  @property({ type: String })
  theme: NewsCardTheme = 'dark';

  connectedCallback() {
    super.connectedCallback();

    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  render(): TemplateResult {
    return html`
      <div class="news-card">
        <slot name="eyebrow"></slot>
        <slot name="title"></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-news-card': PCNewsCard;
  }
}
